var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.293V17H0V0Z",
    fill: "#D6D4D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.208496 0.208588H25.0865V16.7945H0.208496V0.208588Z",
    fill: "#162B74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0865 0.210083H22.0967L12.6474 6.50954L3.19825 0.210083H0.208496V2.20268L9.65777 8.50213L0.208496 14.8018V16.7945H3.19825L12.6474 10.495L22.0967 16.7945H25.0865V14.8018L15.6374 8.50213L25.0865 2.20268V0.210083Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.208496 0.210114V1.20564L12.6474 9.49932V8.50216L0.208496 0.210114Z",
    fill: "#CE102A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0865 15.7988L12.6475 7.50519V8.50208L25.0865 16.7945V15.7988Z",
    fill: "#CE102A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.208496 16.7945H1.70269L12.6474 9.49924V8.50208L0.208496 16.7945Z",
    fill: "#CE102A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5924 0.210052L12.6475 7.50648V8.50355L25.0851 0.210052H23.5924Z",
    fill: "#CE102A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0865 7.05094H13.6846V0.210114H11.6105V7.05094H0.208496V9.95365H11.6105V16.7946H13.6846V9.95365H25.0865V7.05094Z",
    fill: "#CE142B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7805 0.210114V6.22094H0.208496V7.05094H11.6105V0.210114H10.7805Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.208496 10.7819H10.7805V16.7945H11.6105V9.95355H0.208496V10.7819Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0867 9.95355H13.6848V16.7945H14.5148V10.7819H25.0867V9.95355Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0867 6.22088H14.5148V0.210052H13.6848V7.05088H25.0867V6.22088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF7);
export default __webpack_public_path__ + "static/media/f7.6d918f5e09f6bb5b3b37ceb88f228c55.svg";
export { ForwardRef as ReactComponent };